import type { LogAction, LogActionFailure, LogActionSuccess } from 'app/lib/types/server';
import type { ReduxActionOutcome, ReduxApiAction } from 'app/store/storeTypes';
import { LOG_TO_BACKEND } from './types.js';

type LogActionTypeMap = {
    Params: LogAction;
    Success: LogActionSuccess;
    Failure: LogActionFailure;
};

export const doLogToBackend = (
    userActionKey: string,
    userActionValue: string,
    properties: Record<string, unknown>
) =>
    ({
        type: LOG_TO_BACKEND,
        api: { version: 2, name: 'LogAction' },
        context: { userActionKey, userActionValue, properties }
    }) as const satisfies ReduxApiAction<LogActionTypeMap>;

export type LogToBackendActionOutcome = ReduxActionOutcome<
    ReturnType<typeof doLogToBackend>,
    LogActionTypeMap
>;
